var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer fix-footer"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_vm._v(" Пишите нам "),_c('a',{attrs:{"href":"mailto:help@swimtime.ru"}},[_c('b-icon',{attrs:{"icon":"envelope"}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }